export default __webpack_public_path__ + "static/media/GroupRemoveBlack.777d769e.svg";